<div [class]="containerClasses()">
    @if (label()) {
        <label [for]="inputId">
            {{ label() | translate }}
            @if (isRequired()) {
                <span class="text-danger" aria-label="required">*</span>
            }
            @if (labelTooltip()) {
                <i class="ti ti-info-circle-filled text-muted ti-sm" ngbTooltip="{{labelTooltip() | translate}}"></i>
            }
        </label>
    }

    <div>
        <ng-select #selectElement
                   [items]="items()"
                   [bindLabel]="computedBindLabel()"
                   [bindValue]="computedBindValue()"
                   [placeholder]="computedPlaceholder() | translate"
                   [multiple]="multiple()"
                   [clearable]="clearable()"
                   [searchable]="searchable()"
                   [closeOnSelect]="closeOnSelect()"
                   [selectOnTab]="selectOnTab()"
                   [openOnEnter]="openOnEnter()"
                   [dropdownPosition]="dropdownPosition()"
                   [appendTo]="appendTo()"
                   [maxSelectedItems]="maxSelectedItems()"
                   [hideSelected]="hideSelected()"
                   [loadingText]="computedLoadingText() | translate"
                   [notFoundText]="computedNotFoundText() | translate"
                   [typeToSearchText]="computedTypeToSearchText() | translate"
                   [addTagText]="computedAddTagText() | translate"
                   [clearAllText]="computedClearAllText() | translate"
                   [addTag]="addTag()"
                   [editableSearchTerm]="editableSearchTerm()"
                   [selectableGroup]="selectableGroup()"
                   [selectableGroupAsModel]="selectableGroupAsModel()"
                   [minTermLength]="minTermLength()"
                   [typeahead]="typeahead()"
                   [virtualScroll]="virtualScroll()"
                   [groupBy]="computedGroupBy()"
                   [compareWith]="computedCompareWith()"
                   [disabled]="isDisabled()"
                   [readonly]="readonly()"
                   [class.ng-invalid]="isInvalid"
                   [class.ng-touched]="isTouched"
                   [class.ng-dirty]="isDirty"
                   [(ngModel)]="currentValue"
                   (focus)="onFocus()"
                   (blur)="onBlur()"
                   (open)="onOpen()"
                   (close)="onClose()"
                   (clear)="onClear()"
                   (add)="onAdd($event)"
                   (remove)="onRemove($event)"
                   (scroll)="onScroll($event)"
                   (change)="onValueChange($event)"
                   (scrollToEnd)="onScrollToEnd()"
                   (search)="onSearch($event)">

            <!-- Template customizado para opções no dropdown -->
            <ng-template ng-option-tmp let-item="item" let-index="index">
                <!-- Verifica se há template customizado -->
                @if (hasCustomOptionTemplate()) {
                    <ng-container *ngTemplateOutlet="customOptionTemplate; context: {$implicit: item, item: item, index: index}"></ng-container>
                } @else {
                    <!-- Template padrão -->
                    {{ (bindLabel() ? item[bindLabel()] : item) | translate }}
                }
            </ng-template>

            <!-- Template customizado para itens selecionados -->
            <ng-template ng-label-tmp let-item="item" let-clear="clear" let-index="index">
                <span class="ng-value-label">
                    <!-- Verifica se há template customizado para label -->
                    @if (hasCustomLabelTemplate()) {
                        <ng-container *ngTemplateOutlet="customLabelTemplate; context: {$implicit: item, item: item, index: index}"></ng-container>
                    } @else {
                        <!-- Template padrão -->
                        {{ (bindLabel() ? item[bindLabel()] : item) | translate }}
                    }
                </span>
                @if (multiple() && !isDisabled() && !readonly()) {
                    <span class="ng-value-icon right"
                          (click)="clear(item)"
                          aria-hidden="true">×</span>
                }
            </ng-template>

            <!-- Template customizado para header -->
            @if (hasCustomHeaderTemplate()) {
                <ng-template ng-header-tmp>
                    <ng-container *ngTemplateOutlet="customHeaderTemplate; context: {items: items(), selectedCount: currentValue?.length || 0}"></ng-container>
                </ng-template>
            }

            <!-- Template customizado para footer ou footer padrão -->
            @if (hasCustomFooterTemplate()) {
                <ng-template ng-footer-tmp>
                    <ng-container *ngTemplateOutlet="customFooterTemplate; context: {items: items(), selectedCount: currentValue?.length || 0}"></ng-container>
                </ng-template>
            } @else if (multiple() && !maxItemsPerGroup()) {
                <!-- Footer padrão -->
                <ng-template ng-footer-tmp>
                    <div class="d-flex justify-content-center gap-3">
                        <button type="button"
                                class="btn btn-link txt-dark p-0 text-decoration-none"
                                [disabled]="areAllSelected() || isDisabled() || readonly()"
                                (click)="selectAll()">
                            <i class="ti ti-checkbox me-1"></i>
                            Selecionar todos
                        </button>
                        <button type="button"
                                class="btn btn-link text-secondary p-0 text-decoration-none"
                                [disabled]="!currentValue?.length || isDisabled() || readonly()"
                                (click)="deselectAll()">
                            <i class="ti ti-trash me-1"></i>
                            Limpar seleção
                        </button>
                    </div>
                </ng-template>
            }

            <!-- Template customizado para grupo -->
            @if (hasCustomGroupTemplate()) {
                <ng-template ng-optgroup-tmp let-item="item" let-index="index">
                    <ng-container *ngTemplateOutlet="customGroupTemplate; context: {$implicit: item, item: item, index: index}"></ng-container>
                </ng-template>
            }

            <!-- Template customizado para loading -->
            @if (hasCustomLoadingTemplate()) {
                <ng-template ng-loadingspinner-tmp>
                    <ng-container *ngTemplateOutlet="customLoadingTemplate"></ng-container>
                </ng-template>
            }

            <!-- Template customizado para not found -->
            @if (hasCustomNotFoundTemplate()) {
                <ng-template ng-notfound-tmp>
                    <ng-container *ngTemplateOutlet="customNotFoundTemplate"></ng-container>
                </ng-template>
            }

            <!-- Template customizado para type to search -->
            @if (hasCustomTypeToSearchTemplate()) {
                <ng-template ng-typetosearch-tmp>
                    <ng-container *ngTemplateOutlet="customTypeToSearchTemplate"></ng-container>
                </ng-template>
            }

        </ng-select>
    </div>

    @if (hint()) {
        <div class="form-text text-muted" [id]="inputId + '_hint'">
            <i class="ti {{hintIcon()}}"></i> {{ hint() | translate }}
        </div>
    }

    @if (showErrorDescription()) {
        @if (ngControl?.control) {
            <app-control-error
                    [control]="getControl()"
                    [customErrors]="customErrors()">
            </app-control-error>
        }
    }
</div>
